import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, CardMedia, Grid, Divider, Button, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

const projects = [
  {
    title: 'Vendor Management System',
    description: 'Temporary staffing management tool: recruitment, assignment to missions, time tracking, client invoicing, and administrative compliance',
    image: 'https://res.cloudinary.com/dx8jbju8t/image/upload/v1745159589/ppms_04_eqd32v.jpg',
    link: 'https://your-ecommerce.com',
    github: 'https://github.com/your-username/ecommerce',
    category: 'saas',
    

  },
  {
    title: 'ERP',
    description: 'Enterprise Resource Planning for project and HR management',
    image: 'https://res.cloudinary.com/dx8jbju8t/image/upload/v1745674473/stark02_nmjpxe.png',
    link: 'https://your-ecommerce.com',
    github: 'https://github.com/your-username/ecommerce',
    category: 'saas',

  },
  {
    title: 'FFR Competiton',
    description: 'Competition website for FFR make with React | flow.',
    image: 'https://res.cloudinary.com/dx8jbju8t/image/upload/v1745159589/FFR_O1_uqhd6b.png',
    link: 'https://your-portfolio.com',
    github: 'https://github.com/your-username/portfolio',
    category: 'saas',
  },
  {
    title: 'Foodact',
    description: 'A React Native app anti-food waste.',
    image: 'https://res.cloudinary.com/dx8jbju8t/image/upload/v1745410120/Screenshot_20210324_094527_host.exp.exponent_zqwziv.png',
    link: 'https://mobile-project.com',
    github: 'https://github.com/your-mobile-project',
    category: 'mobile',
  },
  {
    title: 'FFR Compettion',
    description: 'A React Native app for tracking the French Rugby Federation’s competitions.',
    image: 'https://res.cloudinary.com/dx8jbju8t/image/upload/v1745410121/Screenshot_20250419_112601_fr.ffr.competitions.android_rfev01.png',
    link: 'https://mobile-project.com',
    github: 'https://github.com/your-mobile-project',
    category: 'mobile',
  },
  {
    title: 'CookSmartApp',
    description: 'A React Native app for managing recipes, shopping lists, and planning.',
    image: 'https://res.cloudinary.com/dx8jbju8t/image/upload/v1745410120/Simulator_Screenshot_-_iPhone_16_Pro_-_2025-03-26_at_15.32.04_2_zjvff3.png',
    link: 'https://mobile-project.com',
    github: 'https://github.com/your-mobile-project',
    category: 'mobile',
  },
  
  // Ajoute autant de projets que tu veux
];

const Projects: React.FC = () => {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState<'saas' | 'mobile'>('saas');
  const [loadedMap, setLoadedMap] = useState<Record<number, boolean>>({});
  const filteredProjects = projects.filter(
    (project) => project.category === selectedCategory
  );

  useEffect(() => {
    filteredProjects.forEach((project, idx) => {
      const img = new Image();
      img.src = project.image;
      img.onload = () => {
        setLoadedMap(prev => ({ ...prev, [idx]: true }));
      };
    });
    // on nettoie l'état de loadedMap pour cette nouvelle catégorie
    return () => setLoadedMap({});
  }, [selectedCategory]);

  
  return (
    <Box
      sx={{
        backgroundColor: '#4a4f54',
        padding: 4,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        borderRadius: 4,
        width: '88%',
        margin: 'auto',
        marginBottom: 8
      }}
    >
      <Typography variant="h4" sx={{ mb: 1, textAlign:'left', color: '#fff' }}>
        {t('projects')}
      </Typography>
      <Divider
        sx={{
          marginBottom: 4,
          width: '103%',
          backgroundColor: 'white',
          alignSelf: 'center',
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4, gap: 2 }}>
        <Button
          variant="outlined"
          onClick={() => setSelectedCategory('saas')}
          sx={{
            borderRadius: 20,
            borderColor: selectedCategory === 'saas' ? '#26c6da' : 'grey.600',
            color: 'white',
            backgroundColor: selectedCategory === 'saas' ? '#1a1b1f' : 'transparent',
            '&:hover': {
              borderColor: '#26c6da',
              backgroundColor: '#1a1b1f',
            },
            textTransform: 'none', // pas de majuscule forcée
            px: 3,
            py: 1,
            fontWeight: 'bold',
          }}
        >
          SaaS / Web
        </Button>
        
        <Button
          variant="outlined"
          onClick={() => setSelectedCategory('mobile')}
          sx={{
            borderRadius: 20,
            borderColor: selectedCategory === 'mobile' ? '#26c6da' : 'grey.600',
            color: 'white',
            backgroundColor: selectedCategory === 'mobile' ? '#1a1b1f' : 'transparent',
            '&:hover': {
              borderColor: '#26c6da',
              backgroundColor: '#1a1b1f',
            },
            textTransform: 'none',
            px: 3,
            py: 1,
            fontWeight: 'bold',
          }}
        >
          Mobile
        </Button>
      </Box>

      <Grid container spacing={4}>
        {filteredProjects.map((project, index) => (
          <Grid item xs={12} sm={4} md={4} key={index}>
            <Card
              sx={{
                padding: 2,
                backgroundColor: '#4a4f54',
                color: 'white',
                height: 230,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
               {!loadedMap[index] && (
                <Skeleton variant="rectangular" height={140} animation="wave" />
              )}
              <CardMedia
                component="img"
                height="140"
                image={project.image}
                alt={project.title}
                sx={{objectFit: 'fill'}}
                
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="body1" component="div">
                  {project.title}
                </Typography>
                <Typography 
                  variant="body2" 
                  color="grey.400" 
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2, // limite à 3 lignes
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {project.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Projects;
